function getCurrentTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function convertEpochToTimestamp(epochTime) {
  const date = new Date(epochTime);
  // Get the user's system timezone
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Configure options for 12-hour format, with AM/PM, and without seconds
  const options = {
    timeZone: userTimeZone,
    hour: "numeric", // Display the hour
    minute: "numeric", // Display the minute
    hour12: true, // Use 12-hour format with AM/PM
    // seconds: undefined or simply omitted, as it's not included by default with just hour and minute
  };

  const formattedTime = date.toLocaleTimeString(undefined, options);
  return formattedTime;
}

function convertEpochToDate(epochTime) {
  // Convert to milliseconds if it's in seconds
  if (epochTime < 1e12) {
    epochTime *= 1000;
  }

  const date = new Date(epochTime);

  if (isNaN(date.getTime())) {
    console.error("Invalid epoch time");
    return "";
  }
  
  return new Intl.DateTimeFormat(navigator.language, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

const convertCreatedAtToUserTime = (epochTime) => {
  // Convert to milliseconds if it's in seconds
  if (epochTime < 1e12) {
    epochTime *= 1000;
  }

  const date = new Date(epochTime);

  if (isNaN(date.getTime())) {
    console.error("Invalid epoch time");
    return "";
  }

  return new Intl.DateTimeFormat(navigator.language, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false // Or true if you want AM/PM based on locale
  }).format(date);
};



export { convertEpochToDate, convertEpochToTimestamp, getCurrentTimeZone, convertCreatedAtToUserTime };
